import generalStyles from '@/components/General/Styles.module.scss';
import { MultiSelectColumnFilter } from '../General/MultiSelectColumnFilter';
import { FILTER_TYPES } from '../General/DataTable';
import { DateRangeColumnFilter } from '../General/DateRangeColumnFilter';
import { Link } from 'react-router-dom';

const APPROVAL_NEEDED_REASON_LABELS = {
    domain_match: 'Domain Match',
    tpa: 'TPA',
    multi_company: 'Multi Company',
};

export const COLUMNS = [
    {
        Header: 'First Name',
        accessor: 'firstName',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
    },
    {
        Header: 'Last Name',
        accessor: 'lastName',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
    },
    {
        Header: 'User Email',
        accessor: 'userEmail',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
    },
    {
        Header: 'Company Name',
        accessor: 'companyName',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
        Cell: ({ row, value }) => (
            <Link className={generalStyles.link} to={`/newcompanypage/${row.original.nsCompanyId}`}>
                {value}
            </Link>
        ),
    },
    {
        Header: 'Company Domain',
        accessor: 'companyDomains',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
        Cell: ({ row, value }) => (
            <Link className={generalStyles.link} to={`/newcompanypage/${row.original.nsCompanyId}`}>
                {value}
            </Link>
        ),
    },
    {
        Header: 'Matched Accounts',
        accessor: (row) => row.matchedAccounts?.join(', ') ?? '',
        id: 'matchedAccounts',
        className: generalStyles.tableCell,
    },
    {
        Header: 'Invited Date',
        accessor: (row) => row.invitedDtm,
        id: 'invitedDtm',
        className: generalStyles.tableCell,
        Filter: DateRangeColumnFilter,
        filter: FILTER_TYPES.dateRange,
        Cell: ({ value }) => {
            const date = value ? new Date(value) : null;
            return date && !Number.isNaN(date.getTime()) ? date.toLocaleDateString() : '';
        },
    },
    {
        Header: 'Invite Source',
        accessor: 'invitationSource',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
    },
    {
        Header: 'Invitation Approval Status',
        accessor: 'invitationApprovalStatus',
        className: generalStyles.tableCell,
        Filter: MultiSelectColumnFilter,
        filter: FILTER_TYPES.multiple,
    },
    {
        Header: 'Request Details',
        accessor: 'requestDetails',
        className: generalStyles.tableCell,
    },
    {
        Header: 'Flag',
        accessor: (row) => {
            const reasonCode = row.approvalNeededReasonCode;
            return APPROVAL_NEEDED_REASON_LABELS[reasonCode] ?? reasonCode ?? '';
        },
        id: 'approvalNeededReasonCode',
        className: generalStyles.tableCell,
    },
]
